import React from 'react';

const Footer = () => {
  return (
    <div>
 <div className="right-sidebar scrollbar-enabled">
                <div className="sidebar-chat" data-plugin="chat-sidebar">
                    <div className="sidebar-chat-info">
                        <h3>Chat</h3>
                        <p className="text-muted">You can chat with your family and friends in this space.</p>
                    </div>
                    <div className="chat-list">
                        <h6 className="sidebar-chat-subtitle">Online</h6>
                        <div className="list-group row">
                            <a href="javascript:void(0)" className="list-group-item user--online thumb-xs" data-chat-user="Julein Renvoye">
                            <img src="/admin/assets/demo/users/user1.jpg" className="rounded-circle" alt=""/> <span className="name">Julien Renvoye</span>  <span className="username">@jrenvoye</span> 
                        </a>
                            <a href="javascript:void(0)" className="list-group-item user--online thumb-xs" data-chat-user="Eddie Lebanovkiy">
                            <img src="/admin/assets/demo/users/user2.jpg" className="rounded-circle" alt=""/> <span className="name">Eddie Lebanovskiy</span>  <span className="username">@elebano</span> 
                        </a>
                            <a href="javascript:void(0)" className="list-group-item user--away thumb-xs" data-chat-user="Cameron Moll">
                            <img src="/admin/assets/demo/users/user3.jpg" className="rounded-circle" alt=""/> <span className="name">Cameron Moll</span>  <span className="username">@cammoll</span> 
                        </a>
                            <a href="javascript:void(0)" className="list-group-item user--busy thumb-xs" data-chat-user="Bill S Kenny">
                            <img src="/admin/assets/demo/users/user7.jpg" className="rounded-circle" alt=""/> <span className="name">Bill S Kenny</span>  <span className="username">@billsk</span> 
                        </a>
                            <a href="javascript:void(0)" className="list-group-item user--busy thumb-xs" data-chat-user="Trent Walton">
                            <img src="/admin/assets/demo/users/user6.jpg" className="rounded-circle" alt=""/> <span className="name">Trent Walton</span>  <span className="username">@trentwalton</span>
                        </a>
                        </div>
                        
                    </div>
                    
                    <div className="chat-list">
                        <h6 className="sidebar-chat-subtitle">Offline</h6>
                        <div className="list-group row">
                            <a href="javascript:void(0)" className="list-group-item user--offline thumb-xs" data-chat-user="Julien Renvoye">
                            <img src="/admin/assets/demo/users/user1.jpg" className="rounded-circle" alt=""/> <span className="name">Julien Renvoye</span>  <span className="username">@jrenvoye</span> 
                        </a>
                            <a href="javascript:void(0)" className="list-group-item user--offline thumb-xs" data-chat-user="Eddie Lebaovskiy">
                            <img src="/admin/assets/demo/users/user2.jpg" className="rounded-circle" alt=""/> <span className="name">Eddie Lebanovskiy</span>  <span className="username">@elebano</span> 
                        </a>
                            <a href="javascript:void(0)" className="list-group-item user--offline thumb-xs" data-chat-user="Cameron Moll">
                            <img src="/admin/assets/demo/users/user3.jpg" className="rounded-circle" alt=""/> <span className="name">Cameron Moll</span>  <span className="username">@cammoll</span> 
                        </a>
                            <a href="javascript:void(0)" className="list-group-item user--offline thumb-xs" data-chat-user="Bill S Kenny">
                            <img src="/admin/assets/demo/users/user7.jpg" className="rounded-circle" alt=""/> <span className="name">Bill S Kenny</span>  <span className="username">@billsk</span> 
                        </a>
                            <a href="javascript:void(0)" className="list-group-item user--offline thumb-xs" data-chat-user="Trent Walton">
                            <img src="/admin/assets/demo/users/user6.jpg" className="rounded-circle" alt=""/> <span className="name">Trent Walton</span>  <span className="username">@trentwalton</span>
                        </a>
                        </div>
                        
                    </div>
                     
                </div>
                 
            </div>
            
            <div className="chat-panel" hidden>
                <div className="card">
                    <div className="card-header">
                        <button type="button" className="close" aria-label="Close"><span aria-hidden="true">&times;</span>
                    </button>
                        <button type="button" className="minimize" aria-label="Minimize"><span aria-hidden="true"><i className="material-icons">expand_more</i></span>
                    </button> <span className="user-name">John Doe</span>
                    </div>
                    
                    <div className="card-block custom-scroll">
                        <div className="messages custom-scroll-content scrollbar-enabled">
                            <div className="current-user-message">
                                <img className="user-image" width="30" height="30" src="/admin/assets/demo/users/user1.jpg" alt=""/>
                                <div className="message">
                                    <p>Lorem ipsum dolor sit amet?</p><small>10:00 am</small>
                                </div>
                                
                            </div>
                             
                            <div className="other-user-message">
                                <img className="user-image" width="30" height="30" src="/admin/assets/demo/users/user2.jpg" alt=""/>
                                <div className="message">
                                    <p>Etiam rhoncus. Maecenas tempus, tellus eget condi mentum rhoncus</p><small>10:00 am</small>
                                </div>
                                
                            </div>
                            
                            <div className="current-user-message">
                                <img className="user-image" width="30" height="30" src="/admin/assets/demo/users/user1.jpg" alt=""/>
                                <div className="message">
                                    <img src="/admin/assets/demo/chat-message.jpg" alt=""/> <small>10:00 am</small>
                                </div>
                                 
                            </div>
                           
                            <div className="current-user-message">
                                <img className="user-image" width="30" height="30" src="/admin/assets/demo/users/user1.jpg" alt=""/>
                                <div className="message">
                                    <p>Maecenas nec odio et ante tincidunt tempus.</p><small>10:00 am</small>
                                </div>
                                
                            </div>
                            
                            <div className="other-user-message">
                                <img className="user-image" width="30" height="30" src="/admin/assets/demo/users/user2.jpg" alt=""/>
                                <div className="message">
                                    <p>Donec sodales :)</p><small>10:00 am</small>
                                </div>
                               
                            </div>
                            
                        </div>
                        
                        <form action="javascript:void(0)" method="post">
                            <textarea name="message" style={{ resize: "none" }} placeholder="Type message and hit enter"></textarea>
                            <ul className="list-unstyled list-inline chat-extra-buttons">
                                <li className="list-inline-item"><a href="javascript:void(0)"><i className="material-icons">insert_emoticon</i></a>
                                </li>
                                <li className="list-inline-item"><a href="javascript:void(0)"><i className="material-icons">attach_file</i></a>
                                </li>
                            </ul>
                            <button className="btn btn-color-scheme btn-circle submit-btn" type="submit"><i className="material-icons">send</i>
                        </button>
                        </form>
                    </div>
                    
                </div>
                
            </div>
             
        
        
       
    </div>
    
	 
         );
}

export default Footer;
